import React from 'react';

import { AmountFormatter } from '@gogame/intl-ts';

const TotalBudgetFormatter = ({ total = {}, max }) => {
  return (
    <React.Fragment>
      {total.currencyCode !== total.currencyCodeBase ? (
        <React.Fragment>
          <AmountFormatter
            amountBase={total.amountBase}
            currencyCodeBase={total.currencyCodeBase}
          />
          <span>&nbsp;-&nbsp;</span>
        </React.Fragment>
      ) : null}
      {max ? (
        <React.Fragment>
          <AmountFormatter
            amount={max.amountBase}
            currencyCode={max.currencyCodeBase}
          />
          <span>&nbsp;max</span>
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
};

export default TotalBudgetFormatter;
